import { motion } from "motion/react";

import { useReducedMotion } from "./ui/use-reduced-motion";

const welcomeHomeVideo = "/videos/WelcomeHomeVideo.mp4";

export default function VideoTextSection() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="relative w-full overflow-hidden px-4 py-16 md:px-8 md:py-24 lg:px-16 lg:py-32">
      <div className="mx-auto w-full max-w-[1600px]">
        <div className="grid items-center gap-8 md:gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left side - Video placeholder */}
          <motion.div
            initial={prefersReducedMotion ? {} : { opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={
              prefersReducedMotion
                ? { duration: 0 }
                : { duration: 0.8, ease: "easeOut" }
            }
            className="relative order-2 mx-auto aspect-[4/3] w-full overflow-hidden rounded-3xl bg-gradient-to-br from-gray-100 to-gray-200 shadow-2xl lg:order-1 lg:mx-0"
          >
            <video
              src={welcomeHomeVideo}
              loop
              preload="auto"
              muted
              playsInline
              autoPlay
              className="h-full w-full object-cover object-center"
            ></video>
          </motion.div>

          {/* Right side - Text content */}
          <motion.div
            initial={prefersReducedMotion ? {} : { opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={
              prefersReducedMotion
                ? { duration: 0 }
                : { duration: 0.8, ease: "easeOut" }
            }
            className="order-1 space-y-6 text-center lg:order-2 lg:text-left"
          >
            <h2
              className="leading-[1.1] tracking-tight text-white"
              style={{ fontSize: "var(--text-section)", fontWeight: "600" }}
            >
              Designers, dreamers — welcome home
            </h2>

            <p
              className="mx-auto max-w-3xl leading-relaxed text-gray-300 lg:mx-0"
              style={{ fontSize: "var(--text-lead)" }}
            >
              We're a team that values authenticity, creativity, and each other.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
